import type { LinearFn2d, Point2d } from ".."

export const whereDoLinesIntersect = (
  fn1: LinearFn2d,
  fn2: LinearFn2d,
): Point2d | undefined => {
  const vertical = !isFinite(fn1.slope)
    ? fn1
    : !isFinite(fn2.slope)
    ? fn2
    : undefined
  if (vertical) {
    const x = vertical(0)
    const y = fn1.intercept

    return { x, y }
  }
  const x = (fn2.intercept - fn1.intercept) / (fn1.slope - fn2.slope)
  const y = fn1(x)

  return { x, y }
}

export const whereDoLinesIntersectUsingPoints = (
  p1: Point2d,
  p2: Point2d,
  p3: Point2d,
  p4: Point2d,
): Point2d | null => {
  // https://observablehq.com/@bumbeishvili/two-unlimited-lines-intersection-in-javascript
  const { x: x1, y: y1 } = p1
  const { x: x2, y: y2 } = p2
  const { x: x3, y: y3 } = p3
  const { x: x4, y: y4 } = p4
  // Check if none of the lines are of length 0
  if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
    return null
  }

  const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1)

  // Lines are parallel
  if (denominator === 0) {
    return null
  }

  const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator
  const ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator

  // Return a object with the x and y coordinates of the intersection
  const x = x1 + ua * (x2 - x1)
  const y = y1 + ua * (y2 - y1)

  return { x, y }
}
